import styled from 'styled-components/macro';
import { colorAccentSuccess500 } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
export const FlexWrapperContainer = styled(FlexWrapper) `
  ${({ isMobileView }) => isMobileView &&
    `
    flex-direction: column-reverse;
    gap: 16px;
  `}
`;
export const ForwardButtonContainerStyled = styled.div `
  svg > path {
    fill: ${colorAccentSuccess500};
  }
`;
